module.exports = __webpack_public_path__ + "static/media/01.20d7723b.jpg";